import { Typography } from '@mui/material';
import { Equipment_Order_STATUSES } from 'API';
import { useIsDesktop } from 'Hooks';

interface IStatus {
  status: number;
  statusLabel: string;
  endDate?: Date;
}

export const Status = ({ status, statusLabel }: IStatus) => {
  const isDesktop = useIsDesktop();

  const blueStyle = {
    backgroundColor: 'primary.shade_100',
    borderColor: 'primary.shade_200',
  };

  const yellowStyle = {
    backgroundColor: '#FFFCF8',
    borderColor: '#FFEDCE',
  };

  const greenStyle = {
    backgroundColor: '#E0F6EF',
    borderColor: '#B8EAD9',
  };

  const purpleStyle = {
    backgroundColor: 'purple2.shade_100',
    borderColor: 'purple2.shade_200',
  };

  const orangeStyle = {
    backgroundColor: 'orange.shade_100',
    borderColor: 'orange.shade_200',
  };

  let styleColor = blueStyle;

  if (
    status === Equipment_Order_STATUSES.pending ||
    status === Equipment_Order_STATUSES.created
  ) {
    styleColor = blueStyle;
  } else if (
    status === Equipment_Order_STATUSES.unknown ||
    status === Equipment_Order_STATUSES.partialSupplied
  ) {
    styleColor = purpleStyle;
  } else if (status === Equipment_Order_STATUSES.denied) {
    styleColor = orangeStyle;
  } else if (status === Equipment_Order_STATUSES.takenCareBySuperPharm) {
    styleColor = yellowStyle;
  } else if (status === Equipment_Order_STATUSES.finished) {
    styleColor = greenStyle;
  } else if (status === Equipment_Order_STATUSES.supplied) {
    styleColor = greenStyle;
  }

  return (
    <Typography
      variant='body5'
      sx={{
        border: '1px solid',
        padding: isDesktop ? '4px 12px' : '1px 4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: 'max-content',
        borderRadius: '6px',
        ...styleColor,
      }}
    >
      {statusLabel}
    </Typography>
  );
};
